import { RootState } from "integrations/redux/rootReducer"

const root = (state: RootState) => state.map.search

export const selectMapSearchIsActive = (state: RootState) => root(state).isActive

export const selectSearchCoordinate = (state: RootState) => root(state).searchCoordinate
